import { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import LoginScreen from './Screens/LoginScreen';

// reducer
import { authUser } from '../../redux/modules/auth';

// api
import { toast } from 'react-toastify';
import { requestGetUserOtpVia, requestLogin } from '../../api/login';
import OTPModal from './components/OTPModal';
const Login = () => {
  const dispatch = useDispatch();
  const { isAuthed } = useSelector(({ auth }) => auth);
  const [form, setForm] = useState({ username: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [redirectToDashboard, setRedirectToDashboard] = useState(true);
  const [isOtpVia, setIsOtpVia] = useState('');

  const [holder, setHolder] = useState(false);

  const onHandleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    toast.loading('Please wait...');

    Swal.fire({
      title: 'Loading...',
      html: 'Please wait...',
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    getUserOTPDetails();

    requestLogin(form)
      .then((res) => {
        const { code, result, temp_token } = res.data.response;

        if (code === '00000' || code === '200') {
          Swal.close();
          let tmpUser = result?.user;
          let roles = result?.user?.roles?.map(({ role }) => role);

          const isAdmin = result?.user?.roles?.find(
            ({ slug }) => slug === 'admin',
          );

          if (!result?.user) {
            setRedirectToDashboard(false);
            setForm({
              ...form,
              temp_token,
            });
            setShowOtpModal(true);
            setHolder(true);
            toast.dismiss();
          } else {
            //  if (isAuthed) {
            toast.dismiss();
            window.location.href = '/dashboard';
            //}
          }

          if (isAdmin) roles?.push('aaf1');
          //if (!result.permissions.length) roles.push("aaf1");

          dispatch(
            authUser({
              accessToken: result?.access_token,
              user: { ...tmpUser, roles },
              permissions: [...result?.permissions],
            }),
          );
        } else if (code === '00011') {
          Swal.close();
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: result,
          });
        } else {
          Swal.close();
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Invalid Credentials',
          });

          // return;
        }
      })
      .catch((err) => {});
  };

  const onHide = () => {
    setShowOtpModal(false);
  };

  const redirectDashboard = () => {
    //if (isAuthed) {
    window.location.href = '/dashboard';
    //}
  };

  const getUserOTPDetails = async () => {
    try {
      const res = await requestGetUserOtpVia({ username: form.username });

      const { code, result } = res.data.response;

      if (code === '00000') {
        setIsOtpVia(result.otp_via);
      } else {
        setIsOtpVia('');
      }
    } catch (error) {}
  };

  return (
    <Fragment>
      {/* {redirectDashboard()} */}
      <LoginScreen
        form={form}
        onHandleChange={onHandleChange}
        showPassword={showPassword}
        setShowPassword={setShowPassword}
        onSubmit={onSubmitHandler}
      />
      <OTPModal
        showOtpModal={showOtpModal}
        onHide={onHide}
        userCred={form}
        setShowOtpModal={setShowOtpModal}
        isOtpVia={isOtpVia}
        holder={holder}
        setHolder={setHolder}
      />
    </Fragment>
  );
};

export default Login;
